export default {
	api: {
		updated: 'Datensatz aktualisiert'
	},
	common: {
		ok: 'Ok',
		save: 'Speichern',
		saveAndNext: 'Speichern und Weiter',
		yes: 'Ja',
		no: 'Nein',
		cancel: 'Abbrechen',
		update: 'Aktualisieren',
		create: 'Erstellen',
		back: 'Zurück',
		delete: 'Löschen',
		send: 'Senden',
		search: 'Suche...',
		all: 'Alle',
		none: 'Keine',
		unknown: 'Unbekannt',
		assigned: 'Zugeordnet',
		not_assigned: 'Nicht zugeordnet',
		please_select: 'Bitte auswählen',
		saved: 'Gespeichert',
		locked: 'Gesperrt',
		to_login: 'Zum Login',
		expired_session: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
		clear_image: 'Bild löschen',
		preview: 'Vorschau',
		edit: 'Bearbeiten',
		edit_avatar: 'Avatar bearbeiten',
		options: 'Optionen',
		service_not_available: 'Es ist ein Fehler aufgetreten, bitte versuchen sie es später erneut.',
		created: 'Erstellt',
		updated: 'Aktualisiert'
	},
	generic: {
		loading: 'Laden',
		previous: 'Vorheriger',
		next: 'Nächster',
		calender: 'Kalender',
		today: 'Heute',
		week: 'Woche',
		add_event: 'Event hinzufügen',
		select_language: 'Sprache Auswählen'
	},
	layouts: {
		header: {
			i18n: {
				locale: {
					en: 'Englisch',
					de: 'Deutsch'
				}
			},
			location: {
				enable: 'Aktivieren',
				disable: 'Deaktivieren',
				force_update: 'Standort jetzt aktualisieren'
			},
			notifications: {
				newNotifications: 'Keine Benachrichtigungen | Eine Benachrichtigung | {count} Benachrichtigungen',
				viewAll: 'Alle anzeigen'
			},
			profile: {
				profile: 'Profil',
				settings: 'Einstellung',
				darkMode: 'Dunkel',
				lightMode: 'Hell',
				autoMode: 'Auto',
				theme: 'Design',
				notifications: 'Benachrichtigung',
				reverbPing: 'Echtzeitverbindung prüfen',
				signOut: 'Abmelden'
			},
			search: {
				placeholder: 'Suche...'
			}
		}
	},
	pages: {
		admin: {
			teams: {
				title: 'Teams',
				create: 'Team erstellen',
				edit: 'Team bearbeiten',
				users: 'Personen',
				events: 'Events'
			},
			events: {
				title: 'Events',
				create: 'Event erstellen',
				edit: 'Event bearbeiten',
				teams: 'Teams'
			},
			users: {
				title: 'Personen',
				teams: 'Teams',
				events: 'Events',
				label: {
					emailNotVerified: 'E-Mail nicht verifiziert',
					is_locked: 'Gesperrt'
				},
				resend_invitation: 'Zugangsdaten erneut senden',
				resend_invitation_confirm:
					"Der Person '{name}' die Zugangsdaten erneut senden? Wer sich noch nie angemeldet hat, erhält neue Zugangsdaten, andernfalls wird ein Link zum Zurücksetzen des Passworts gesendet.",
				invitation_sent: 'Die Einladung mit neuen Zugangsdaten wurde per E-Mail versendet.',
				password_reset_sent: 'Ein Link zum Zurücksetzen des Passworts wurde per E-Mail versendet.',
				resend_failed: 'Die E-Mail konnte nicht versendet werden.'
			},
			settings: {
				roles_and_permissions: {
					roles: 'Rollen',
					permissions: 'Berechtigungen'
				},
				context_roles_and_permissions: {
					context_roles: 'Context Rollen',
					context_permissions: 'Context Berechtigungen'
				},
				map: {
					general: 'Allgemein',
					preview: 'Vorschau',
					layer: 'Pläne',
					overlays: 'Overlays'
				},
				webhooks: {
					title: 'Webhooks'
				}
			},
			webhook_requests: {
				title: 'Webhook Requests'
			}
		},
		context: {
			users: {
				title: 'Personen'
			}
		},
		me: {
			notifications: {
				title: 'Benachrichtigungen',
				email: {
					title: 'e-Mail',
					text: 'Hier kannst du e-Mail Benachrichtigungen aktivieren oder deaktivieren.',
					activate: 'e-Mail Benachrichtigungen aktivieren'
				},
				email_activate: 'e-Mail Benachrichtigungen aktivieren',
				pushover: {
					title: 'Pushover',
					text: 'Pushover als Notification Channel benutzen',
					activate: 'Pushover Notification Channel aktivieren',
					user_key: 'Pushover User Key'
				}
			},
			security: {
				title: 'Sicherheit',
				pat: {
					title: 'PAT',
					text: 'Verwalte deine Private Access Tokens'
				}
			}
		},
		profile: {
			firstname: 'Vorname',
			lastname: 'Nachname',
			email: 'E-Mail-Adresse',
			current_password: 'Aktuelles Passwort',
			new_password: 'Neues Passwort',
			password: 'Passwort',
			password_text: 'Versichere dich dass du ein langes und zufälliges Passwort benutzt um sicher zu bleiben',
			password_confirm: 'Neues Passwort bestätigen',
			profile_updated: 'Profil aktualisiert',
			password_updated: 'Passwort aktualisiert',
			avatar: 'Avatar',
			avatar_text: 'Wähle ein individuelles Profilbild.',
			profile: 'Profil',
			profile_text: 'Update die Informationen deines Profils.'
		},
		auth: {
			login: {
				title: 'Loggen Sie sich in Ihr Konto ein',
				text: 'Geben Sie Benutzernamen und Passwort ein.',
				email: 'E-Mail-Adresse',
				password: 'Passwort',
				rememberMe: 'Angemeldet bleiben',
				signIn: 'Anmelden',
				loading: 'Anmeldung läuft...',
				register: {
					text: 'Sie haben noch kein Konto?',
					link: 'Mit E-Mail-Adresse registrieren'
				},
				passwordReset: {
					link: 'Passwort vergessen?'
				},
				error: {
					invalidLogin: 'Ungültige E-Mail-Adresse oder ungültiges Passwort.'
					//notVerified: 'Ihre E-Mail-Adresse wurde noch nicht verifiziert. Bitte nutze den Link in der Anmeldebestätigung.',
					//ylocked: 'Ihr Login wurde deaktiviert. Bitte melde dich bei support@crewadmin.de',
				},
				social: {
					divider: 'oder',
					google: 'Mit Google anmelden',
					microsoft: 'Mit Microsoft-Konto anmelden',
					apple: 'Mit Apple anmelden',
					keycloak: 'Mit Keycloak anmelden',
					authentik: 'Mit Authentik anmelden'
				}
				//resendVerification: 'Anmeldebestätigung erneut senden.',
			},
			register: {
				title: 'Erstellen Sie sich Ihr Konto',
				text: 'Geben Sie Ihre Daten ein.',
				firstname: 'Vorname',
				lastname: 'Nachname',
				email: 'E-Mail-Adresse',
				password: 'Passwort',
				confirmPassword: 'Passwort bestätigen',
				acceptTerms: 'Ich habe die <a href="{href}">Datenschutzerklärung</a> zur Kenntnis genommen.',
				signUp: 'Mit E-Mail-Adresse registrieren',
				disabled: 'Registrierung ist deaktiviert',
				login: {
					text: 'Sie haben bereits ein Konto?',
					link: 'Mit E-Mail-Adresse oder SSO anmelden'
				},
				error: {
					emailExists: 'Die E-Mail-Adresse ist bereits registriert.'
				},
				mailTaken: 'Die E-Mail-Adresse wird bereits genutzt.',
				completedText: 'Bitte überprüfen Sie das E-Mail-Postfach. Wir haben Ihnen eine E-Mail mit den Anweisungen zum Anmelden zugesandt.'
			},
			passwordReset: {
				title: 'Passwort zurücksetzen',
				text: 'Geben Sie Ihre E-Mail-Adresse ein und wir werden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts zusenden.',
				email: 'E-Mail-Adresse:',
				sendResetLink: 'Weiter',
				completedText:
					'Bitte überprüfen Sie das E-Mail-Postfach. Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts zugesandt.'
			},
			newPassword: {
				title: 'Passwort zurücksetzen',
				text: 'Geben Sie ein neues Passwort ein.',
				email: 'E-Mail-Adresse:',
				newPassword: 'Neues Passwort:',
				confirmPassword: 'Neues Passwort bestätigen:',
				setNewPassword: 'Weiter'
			}
		},
		settings: {
			general: {
				title: 'Allgemein'
			},
			announcements: {
				title: 'Ankündigungen'
			},
			users: {
				title: 'Personen'
			},
			events: {
				title: 'Events'
			},
			teams: {
				title: 'Teams'
			}
		},
		map: {
			context_menu: {
				center: 'Hier zentrieren',
				copy_coordinates: 'Koordinaten kopieren'
			}
		},
		note_book: {
			table_of_content: 'Übersicht',
			add_page: 'Seite hinzufügen'
		}
	},
	validations: {
		required: 'Eingabe benötigt',
		invalidEmail: 'E-Mail-Adresse ungültig'
	},
	sidebar: {
		home: 'Übersicht',
		blank: 'Leer',
		cards: 'Cards',
		graph: 'Graph',
		map: 'Karte',
		table: 'Tabelle',
		users: 'Personen',
		teams: 'Teams',
		events: 'Events',
		settings: 'Einstellungen',
		development: 'Entwicklung',
		swagger: 'Swagger UI',
		support: 'Support'
	},
	table: {
		elementsPerPage: 'Einträge pro Seite',
		currentPageOfTotalPages: 'Seite {current} von {total}',
		currentElementsOfTotalElements: 'Einträge {from} bis {to} von {total}',
		currentElementsOfTotalElementsFilteredNote: '(gefiltert von {total})',
		noElements: 'Keine Einträge'
	},
	components: {
		selectUser: {
			placeholder: 'Person auswählen...'
		}
	},
	filter: {
		status: 'Status',
		role: 'Rolle',
		user: 'Verantw. Person'
	},
	modal: {
		admin: {
			editUser: {
				create: 'Neue Person einladen',
				edit: 'Person bearbeiten'
			},
			editTeam: {
				create: 'Neues Team erstellen',
				edit: 'Team bearbeiten',
				users: 'Personen'
			},
			editEvent: {
				create: 'Neues Event erstellen',
				edit: 'Event bearbeiten',
				users: 'Personen',
				teams: 'Teams'
			},
			editRole: {
				create: 'Neue Rolle erstellen',
				edit: 'Rolle bearbeiten',
				permissions: 'Berechtigungen'
			},
			editWebhook: {
				create: 'Neuen Webhook erstellen',
				edit: 'Webhook bearbeiten',
				auth_none: 'Keine',
				auth_basic: 'HTTP Basic',
				auth_token: 'Query Token',
				webhook_url: 'Webhook URL',
				headers: 'Headers'
			},
			deleteRole: {
				title: 'Rolle löschen',
				text: "Soll die Rolle '{item}' wirklich gelöscht werden?"
			},
			editContextRole: {
				create: 'Neue Context Rolle erstellen',
				edit: 'Context Rolle bearbeiten',
				permissions: 'Berechtigungen'
			},
			deleteContextRole: {
				title: 'Context Rolle löschen',
				text: "Soll die Context basierte Rolle '{item}' wirklich gelöscht werden?"
			}
		},
		editAnnouncement: {
			create: 'Neue Ankündigung erstellen',
			edit: 'Ankündigung bearbeiten'
		},
		addUser: {
			title: 'Person hinzufügen',
			input: 'Person auswählen'
		},
		inviteUser: {
			title: 'Person einladen oder hinzufügen',
			input: 'Suche nach Name oder Mail-Adresse',
			context_role: 'Rolle'
		},
		inviteTeam: {
			title: 'Team hinzufügen'
		},
		editEventLayer: {
			create: 'Neuen Layer erstellen',
			edit: 'Layer bearbeiten'
		},
		editEventOverlay: {
			create: 'Neues Overlay erstellen',
			edit: 'Overlay bearbeiten'
		},
		removeEventLayer: {
			title: 'Karten Layer löschen',
			text: "Soll der Karten Layer '{item}' wirklich gelöscht werden?"
		},
		editMarker: {
			create: 'Neue Markierung erstellen',
			edit: 'Markierung bearbeiten'
		},
		removeMarker: {
			title: 'Markierung löschen',
			text: "Soll die Markierung '{item}' wirklich gelöscht werden?"
		},
		imageUpload: {
			resize_error: 'Das Bild konnte nicht verarbeitet werden.',
			select_image_file: 'Bitte wähle eine Bilddatei aus.'
		},
		deleteArticleImage: {
			title: 'Bild löschen',
			text: 'Möchtest du das Artikelbild wirklich löschen?'
		},
		showLocation: {
			orders: 'Bestellungen',
			cart_items: 'Bestellpositionen'
		},
		tableColumnFilter: {
			title: 'Tabellen Spalten Filter',
			name: 'Name',
			show: 'Anzeigen'
		}
	},
	confirm: {
		remove_announcement: 'Ankündigung entfernen',
		remove_announcement_title: `Die Ankündigung "{title}" entfernen?`,
		removeEventOverlay: {
			title: 'Overlay löschen',
			text: 'Soll des Overlay "{name}" wirklich entfernt werden?'
		},
		deleteWebhook: {
			title: 'Webhook löschen',
			text: 'Soll der Webhook "{item}" wirklich gelöscht werden? Dabei werden auch alle zugehörigen Webhook Requests gelöscht.'
		},
		deleteWebhookRequest: {
			title: 'Webhook Request löschen',
			text: 'Soll der Webhook Request wirklich gelöscht werden?'
		}
	},
	data: {
		team: {
			id: 'Id',
			name: 'Name',
			users_count: '# Personen',
			events_count: '# Events'
		},
		event: {
			id: 'Id',
			name: 'Name',
			prefix: 'Präfix',
			start_at: 'Start',
			end_at: 'Ende',
			show_start_at: 'Start der Veranstaltung',
			show_end_at: 'Ende der Veranstaltung',
			is_locked: 'Gesperrt',
			enabled: 'Aktiv',
			teams_count: '# Teams',
			users_count: '# Personen',
			preferred_crs: 'Bevorzugtes Koordinatensystem',
			coordinates: 'Koordinaten',
			inital_coordinates: 'Start Koordinaten'
		},
		user: {
			id: 'Id',
			firstname: 'Vorname',
			lastname: 'Nachname',
			avatar: 'Avatar',
			labels: 'Label',
			email: 'E-Mail-Adresse',
			role: 'Rolle',
			roles: 'Rollen',
			context_role: 'Rolle',
			context_roles: 'Rollen',
			createdAt: 'Erstellt am',
			last_user_login: 'Letzter Login'
		},
		role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Beschreibung',
			permissions: 'Berechtigungen'
		},
		permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			description: 'Beschreibung'
		},
		context_role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context Model',
			description: 'Beschreibung',
			context_permissions: 'Berechtigungen'
		},
		context_permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context Model',
			description: 'Beschreibung'
		},
		announcement: {
			id: 'Id',
			title: 'Titel',
			type: 'Typ',
			description: 'Beschreibung',
			url: 'URL',
			start_at: 'Startdatum',
			end_at: 'Enddatum'
		},
		event_layer: {
			name: 'Name',
			opacity: 'Deckkraft',
			is_grayscale: 'Graustufen',
			transformation: {
				a0: 'a0',
				b0: 'b0',
				a1: 'a1',
				b1: 'b1',
				a2: 'a2',
				b2: 'b2'
			}
		},
		event_overlay: {
			id: 'Id',
			name: 'Name',
			icon: 'Icon',
			url: 'Url',
			layer: 'Layer',
			format: 'Format',
			opacity: 'Transparenz',
			minZoom: 'Zoom Faktor'
		},
		marker: {
			id: 'Id',
			name: 'Name',
			icon: 'Symbol',
			coordinates: 'Koordinaten',
			description: 'Beschreibung'
		},
		config: {
			card: 'Einstellungen',
			key: 'Key',
			public: 'Public',
			type: 'Typ',
			default: 'Default',
			value: 'Value'
		},
		webhook: {
			id: 'Id',
			name: 'Name',
			class: 'Klasse',
			endpoint: 'API-Endpunkt',
			auth_type: 'Authentifizierung',
			client_id: 'Benutzername',
			client_secret: 'Passwort',
			requests_count: '# Requests'
		},
		webhook_request: {
			service_id: 'Service',
			action: 'Action',
			ip_address: 'IP',
			dns: 'DNS',
			method: 'Methode',
			created_at: 'Zeitpunkt',
			payload: 'Payload',
			data: 'Daten',
			success: 'Status'
		}
	},
	tabs: {
		admin_settings: {
			roles_and_permissions: 'Rollen & Berechtigungen',
			translations: 'Übersetzungen',
			templates: 'Vorlagen',
			webhooks: 'Webhooks',
			settings: 'Einstellungen'
		},
		development: {
			tools: 'Tools',
			stores: 'Stores',
			authentication: 'Authentifizierung',
			select: 'Select Components',
			phpInfo: 'PHP Info',
			redisInfo: 'Redis',
			schemaInfo: 'Schema',
			images: 'Bilder'
		},
		me: {
			general: 'Allgemein',
			notifications: 'Benachrichtigungen',
			security: 'Sicherheit'
		},
		event_settings: {
			map: 'Karte',
			markers: 'Markierung'
		}
	},
	popovers: {
		event: {
			preferred_crs: {
				title: 'Bevorzugtes Koordinatensystem',
				text: 'Koordinatensystem welches als Standard bei dem Event ausgewählt wird.'
			}
		}
	},
	enum: {
		boolean: {
			true: 'Ja',
			false: 'Nein'
		},
		event_state: {
			active: 'Aktiv',
			inactive: 'Inaktiv'
		},
		crs: {
			null: '-',
			'EPSG:4326': 'WGS84 (GPS)',
			'EPSG:3857': 'Webmercator',
			'EPSG:25832': 'UTM Zone 32N',
			'EPSG:25833': 'UTM Zone 33N'
		},
		transformation_input_methode: {
			manual: 'Direkte Eingabe',
			reference: 'Referenzpunkte'
		},
		month_names: {
			undefined: '',
			0: 'Januar',
			1: 'Februar',
			2: 'März',
			3: 'April',
			4: 'Mai',
			5: 'Juni',
			6: 'Juli',
			7: 'August',
			8: 'September',
			9: 'Oktober',
			10: 'November',
			11: 'Dezember'
		},
		day_names: {
			0: 'Sonntag',
			1: 'Montag',
			2: 'Dienstag',
			3: 'Mittwoch',
			4: 'Donnerstag',
			5: 'Freitag',
			6: 'Samstag'
		},
		day_short_names: {
			0: 'So',
			1: 'Mo',
			2: 'Di',
			3: 'Mi',
			4: 'Do',
			5: 'Fr',
			6: 'Sa'
		}
	},
	notification: {
		assigned_to_team: {
			icon: 'fa-building',
			title: 'Zu Team hinzugefügt',
			text: "Du wurdest zum Team '{team_name}' hinzugefügt."
		},
		assigned_to_event: {
			icon: 'fa-campground',
			title: 'Zu Veranstaltung hinzugefügt',
			text: "Du wurdest zur Veranstaltung '{event_name}' hinzugefügt."
		}
	},
	support: {
		subject: '[{app_title}] Supportanfrage',
		body: `Hallo {app_title}-Team,

auf der Seite '{uri}' benötige ich Unterstützung.

Kurzbeschreibung:
...

Priorität/Betroffene:
- Priorität: (Blocker/Hoch/Mittel/Niedrig)
- Betroffene: (z.B. nur ich / Team / alle Nutzer)

Erwartetes Verhalten:
...

Tatsächliches Verhalten:
...

Schritte zur Reproduktion:
1) ...
2) ...
3) ...

Umgebung:
- Browser: ...
- Betriebssystem: ...

Zeitpunkt:
- seit: ...
- zuletzt beobachtet: ...

Fehlermeldung / Logs:
- ...

Ihr könnt mich für Rückfragen erreichen unter: ...

Danke für eure Unterstützung



Weitere Daten:
{data}
`
	}
};
